import { render, staticRenderFns } from "./DossierUsers.vue?vue&type=template&id=2e9e4e71&"
import script from "./DossierUsers.vue?vue&type=script&lang=ts&"
export * from "./DossierUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9e4e71')) {
      api.createRecord('2e9e4e71', component.options)
    } else {
      api.reload('2e9e4e71', component.options)
    }
    module.hot.accept("./DossierUsers.vue?vue&type=template&id=2e9e4e71&", function () {
      api.rerender('2e9e4e71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierUsers.vue"
export default component.exports